import React, { Component } from 'react';
import { Editor, EditorProps } from 'react-draft-wysiwyg';
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './styles.scss';
import { Icons } from '@nxsys/types/icons';

type WysiwygEditorProps = {
  editorStateInit?: any;
  handleChange?: (editorState: any) => void;
  isSimple?: boolean;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
};

// Type assertion to fix React 18 compatibility issue
const EditorComponent = Editor as unknown as React.ComponentType<EditorProps>;

class WysiwygEditor extends Component<WysiwygEditorProps> {
  state = {
    editorState: EditorState.createEmpty(),
  };

  componentDidMount() {
    const { editorStateInit } = this.props;
    if (editorStateInit) {
      this.setState({
        editorState: editorStateInit,
      });
    }
  }

  componentDidUpdate(prevProps: Readonly<WysiwygEditorProps>) {
    const { editorStateInit } = this.props;
    if (prevProps.editorStateInit !== editorStateInit) {
      this.setState({
        editorState: editorStateInit,
      });
    }
  }

  UNSEFE_componentWillReceiveProps(nextProps: WysiwygEditorProps) {
    const { editorStateInit } = nextProps;
    const { editorState } = this.state;
    if (
      editorStateInit &&
      editorStateInit !== this.props.editorStateInit &&
      !editorState.getCurrentContent().hasText()
    )
      this.setState({
        editorState: editorStateInit,
      });
  }

  onEditorStateChange = async (editorState: EditorState) => {
    const { handleChange } = this.props;
    let parseEditor = '';
    if (editorState) {
      this.setState({
        editorState,
      });
      if (editorState.getCurrentContent().hasText()) {
        parseEditor = await draftToHtml(
          convertToRaw(editorState.getCurrentContent()),
        );
        handleChange?.(parseEditor as any);
      } else {
        handleChange?.('<p></p>' as any);
      }
    }
  };

  onDeleteStateChange = () => {
    this.setState({
      editorState: EditorState.createEmpty(),
    });
  };

  render() {
    const { editorState } = this.state;
    const { isSimple, disabled, placeholder, className } = this.props;
    return (
      <EditorComponent
        readOnly={disabled}
        editorState={editorState}
        wrapperClassName={`wrapper-wysiwyg  ${className || ''}`}
        editorClassName="editor-wysiwyg"
        toolbarClassName="toolbar-wysiwyg"
        placeholder={placeholder}
        toolbarCustomButtons={[
          <CustomOption onDelete={this.onDeleteStateChange} />,
        ]}
        toolbar={
          isSimple
            ? {
                // options: ['fontFamily', 'inline'],
                options: ['inline'],
                inline: {
                  inDropdown: false,
                  className: undefined,
                  component: undefined,
                  dropdownClassName: undefined,
                  options: ['bold', 'italic', 'underline'],
                },
              }
            : {}
        }
        onEditorStateChange={this.onEditorStateChange}
      />
    );
  }
}

type CustomOptionProps = {
  onDelete: () => void;
};

class CustomOption extends Component<CustomOptionProps> {
  onDelete = () => {
    const { onDelete } = this.props;
    onDelete();
  };

  render() {
    return (
      <div className="rdw-delete-wrapper">
        <div className="rdw-option-wrapper" onClick={this.onDelete}>
          <Icons.IconDelete />
        </div>
      </div>
    );
  }
}

export default WysiwygEditor;
